import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ClipLoader } from "react-spinners";
import Dashboard from "./Dashboard";
import Login from "./login";
import { UserProvider, useUserContext } from "@/contexts/UserContext";
import ErrorBoundary from "./ErrorBoundary";
import AccountLoadError from "./AccountLoadError";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      cacheTime: 30 * 60 * 1000, // Keep unused data in cache for 30 minutes
    },
  },
});

const AppContent = () => {
  const { user, isLoading, error, setUser } = useUserContext();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <ClipLoader size={100} color={"#facc15"} loading={isLoading} />
      </div>
    );
  }

  if (error) {
    return <AccountLoadError error={error} />;
  }

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return <Dashboard />;
};

const App = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <UserProvider>
              <AppContent />
            </UserProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
